import React, { useEffect, useContext, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import { StoreContext } from './Store';
import * as ROLES from '../constants/roles';

const Auth = ({ children }) => {
  const { user: { user, storeUser },  error: { error } } = useContext(StoreContext);

  useEffect(() => {
    if (!user) {
      const authUser = {
        username: "admin-demo",
      };
      authUser.roles = [];
      if (authUser.username === "admin-demo") {
        authUser.roles.push(ROLES.ADMIN_DEMO);
        storeUser(authUser);
      }
    }
    return () => console.log('Auth unmounted');
  }, [])

  return(
    <Fragment>
      {children}
    </Fragment>
  )
}

export default withRouter(Auth);
